module.exports = __webpack_public_path__ + "img/pr-18.5c2dc965.png";